import { render, staticRenderFns } from "./PartnerCollection.vue?vue&type=template&id=a44d5e40&"
import script from "./PartnerCollection.vue?vue&type=script&lang=js&"
export * from "./PartnerCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports